import { render, staticRenderFns } from "./SpeechCraftEventCreate.vue?vue&type=template&id=afa486f4"
import script from "./SpeechCraftEventCreate.vue?vue&type=script&lang=js"
export * from "./SpeechCraftEventCreate.vue?vue&type=script&lang=js"
import style0 from "./SpeechCraftEventCreate.vue?vue&type=style&index=0&id=afa486f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports